exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button-margin {\n  margin: 5px;\n}\n\n/* required class */\n.my-editor {\n  /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */\n  background: ghostwhite;\n  color: #ccc;\n\n  /* you must provide font-family font-size line-height. Example: */\n  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;\n  font-size: 14px;\n  line-height: 1.5;\n  padding: 5px;\n}\n\n/* optional class for removing the outline */\n.prism-editor__textarea:focus {\n  outline: none;\n}\n", ""]);

// exports
